import { ReactComponent as DownloadIcon } from 'assets/icons/download-icon.svg';
import { StyledDataExportButton } from './styles';
import { useTranslation } from 'react-i18next';
interface IDataExportButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
}
export const DataExportButton = ({ children, onClick }: IDataExportButtonProps) => {
  const { t } = useTranslation();
  return (
    <StyledDataExportButton onClick={onClick}>
      <DownloadIcon className="button-icon" />
      <span className="title">{t('adminPage.dataExportButton')}</span>
    </StyledDataExportButton>
  );
};
